(() => {
  if (window.BMThumbFingerpickInitialized) return;
  window.BMThumbFingerpickInitialized = true;

  const variantOptionValue = (variant, position) => variant.getAttribute(`data-option-${position}`) || '';

  const syncVariant = (root, variant) => {
    if (!variant) return;
    const available = variant.dataset.available === 'true';
    root.querySelectorAll('[data-bm-thumb-price]').forEach((price) => {
      price.textContent = variant.dataset.price;
    });
    root.querySelectorAll('[data-bm-thumb-variant-id]').forEach((input) => {
      input.value = variant.value;
    });
    root.querySelectorAll('[data-bm-thumb-add]').forEach((button) => {
      const text = button.querySelector('[data-atc-button-text]');
      button.disabled = !available;
      if (text) text.textContent = available ? button.dataset.defaultLabel || 'Add to cart' : 'Sold out';
    });
    root.querySelectorAll('[data-bm-thumb-status]').forEach((status) => {
      status.textContent = available ? `${variant.textContent.trim()} is available.` : `${variant.textContent.trim()} is sold out.`;
    });

    const hero = root.querySelector('[data-bm-thumb-hero]');
    if (hero) {
      const orientation = [1, 2, 3]
        .map((position) => variantOptionValue(variant, position))
        .filter(Boolean)
        .join(' ');
      hero.src = /left/i.test(orientation) && variant.dataset.imageUrl
        ? variant.dataset.imageUrl
        : hero.dataset.defaultSrc;
    }
  };

  const syncOptions = (control) => {
    const root = control.closest('[data-bm-thumb-fp]');
    if (!root) return;
    const variantSelect = root.querySelector('[data-bm-thumb-variant]');
    const groups = [...root.querySelectorAll('[data-bm-thumb-option-group]')];
    if (!variantSelect || !groups.length) return;

    const desired = new Map();
    groups.forEach((group) => {
      const selected = group.querySelector('[data-bm-thumb-option]:checked');
      if (selected) desired.set(Number(group.dataset.optionPosition), selected.value);
    });

    const variants = [...variantSelect.options];
    let match = variants.find((variant) =>
      [...desired].every(([position, value]) => variantOptionValue(variant, position) === value)
    );

    if (!match || match.dataset.available !== 'true') {
      const changedPosition = Number(control.dataset.optionPosition);
      match = variants.find((variant) =>
        variant.dataset.available === 'true' && variantOptionValue(variant, changedPosition) === control.value
      ) || variants.find((variant) => variant.dataset.available === 'true');
    }

    if (!match) return;
    variantSelect.value = match.value;
    groups.forEach((group) => {
      const position = Number(group.dataset.optionPosition);
      const value = variantOptionValue(match, position);
      const selected = [...group.querySelectorAll('[data-bm-thumb-option]')].find((input) => input.value === value);
      if (selected) selected.checked = true;
    });
    syncVariant(root, match);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-bm-thumb-option]')) syncOptions(event.target);
  });

  document.querySelectorAll('[data-bm-thumb-options]').forEach((options) => {
    const selected = options.querySelector('[data-bm-thumb-option]:checked');
    if (selected) syncOptions(selected);
  });

  document.querySelectorAll('[data-bm-thumb-video]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const type = trigger.dataset.videoType;
      const id = trigger.dataset.videoId;
      if (!id) return;
      const frame = document.createElement('iframe');
      frame.title = trigger.dataset.videoTitle || 'Product demonstration';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.src = type === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      trigger.replaceWith(frame);
      frame.focus();
    });
  });
})();
